import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const AddCategory = () => {
  const [category, setCategory] = useState("");
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const handleAddNewCategory = () => {
    navigate("/add-category");
  };

  const handleViewAllCategory = () => {
    navigate("/all-category");
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post(
        `${API_BASE_URL}/admin/category`,
        {
          category: category,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((resp) => {
        alert("Category Added Successfully!");
        setCategory("");
        navigate("/all-category");
      })
      .catch((err) => {
        console.log(err);
        alert("Error adding category.");
      });
  };

  return (
    <div id="add-department-inner-wrapper">
      <div className="superheader">
        <div className="departmetHeaderdiv">
          <h5>Category</h5>
          <div className="departmentdiv2">
            <button className="handlenewclass" onClick={handleAddNewCategory}>
              + Add New Category
            </button>
            <button className="allclasses" onClick={handleViewAllCategory}>
              All Category
            </button>
          </div>
        </div>

        <div className="form-school-container">
          <h4 className="department-detail">Add Category</h4>
          <form onSubmit={handleSubmit} className="department-detail-form">
            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Category</label>
              </div>
              <input
                className="school-class-add-input-tag"
                type="text"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                placeholder="Enter Category Name"
                required
              />
            </div>

            <div className="form-school-btns">
              <button className="btn-s" type="submit">
                Save
              </button>
              <button
                className="btn-c"
                type="button"
                onClick={() => navigate(-1)}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddCategory;
